import { useQuery } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { getFacilityAllClassesApi } from './api';

const useAllFacilityClasses = ({ facilityId, settings }) => {
  const { enqueueSnackbar } = useSnackbar();

  const { data, isInitialLoading } = useQuery(['allFacilityClasses'], () => getFacilityAllClassesApi(facilityId), {
    onError: (error) => {
      enqueueSnackbar(error.message, { variant: 'error' });
    },
    select: ({ data }) => data,

    ...settings,
  });

  return { allFacilityClasses: data || [], isLoading: isInitialLoading };
};

export default useAllFacilityClasses;
